import { FormSetting } from '@/form-settings/form-setting';
import { User } from '@/models/user.model';

export class SubAgentFormSetting extends FormSetting {
  protected static classToCall: string;

  public static setClassToCall(classes) {
    this.classToCall = classes;

    return this;
  }

  public static getMeta(): Array<any> {
    return [
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'descrizione',
            label: 'Descrizione',
            controlType: 'textinput',
            class: 'lg:w-6/12 w-full',
            order: 1,
            required: true,
          },
          {
            classToUse: this.classToCall,
            key: 'users',
            label: 'Utenti in agenzia',
            controlType: 'multiselect',
            compareFn: (o1: User, o2: User) => o1?.username === o2?.username,
            class: 'lg:w-6/12 w-full',
            order: 1,
            required: false,
            options: this.data['users'] ?? [],
          },
          {
            classToUse: this.classToCall,
            key: 'referenti',
            label: 'Referenti in Paolo Crespi',
            controlType: 'multiselect',
            compareFn: (o1: User, o2: User) => o1?.username === o2?.username,
            class: 'lg:w-6/12 w-full',
            order: 1,
            required: false,
            options: this.data['referenti'] ?? [],
          },
          {
            classToUse: this.classToCall,
            key: 'enabled',
            controlType: 'slide-toggle',
            label: 'Abilitato',
            order: 1,
            default: true,
            class: 'w-full',
          },
        ],
        order: 1,
      },
      {
        rows: [
          {
            classToUse: this.classToCall,
            key: 'id',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
          {
            classToUse: this.classToCall,
            key: 'creator',
            controlType: 'hidden',
            label: '',
            order: 1,
          },
        ],
        order: 1,
      },
    ];
  }
}
